import {} from '../..';
import { Observable } from '../../utils/reactive';
import { userActionStart, userActionStartByApiCallEventName } from './const';
import { UserActionState, } from './types';
import UserAction from './userAction';
export const userActionsMessageBus = new Observable();
export function initializeUserActionsAPI({ transports, internalLogger, config, }) {
    const trackUserActionsExcludeItem = config.trackUserActionsExcludeItem;
    // Currently running user action. It can be in either started or halted
    // state
    let activeUserAction;
    // If there is a an action already running, return undefined to indicate
    // we were not able to create one.
    const startUserAction = (name, attributes, options) => {
        const currentRunningUserAction = getActiveUserAction();
        if (currentRunningUserAction === undefined) {
            const userAction = new UserAction({
                name,
                transports,
                attributes,
                trigger: (options === null || options === void 0 ? void 0 : options.triggerName) || userActionStartByApiCallEventName,
                trackUserActionsExcludeItem,
            });
            userAction
                .filter((v) => [UserActionState.Ended, UserActionState.Cancelled].includes(v))
                .first()
                .subscribe(() => {
                activeUserAction = undefined;
            });
            userActionsMessageBus.notify({
                type: userActionStart,
                userAction: userAction,
            });
            activeUserAction = userAction;
            return activeUserAction;
        }
        else {
            internalLogger.error('Attempted to create a new user action while one is already running. This is not possible.');
            return undefined;
        }
    };
    const getActiveUserAction = () => {
        return activeUserAction;
    };
    return {
        startUserAction,
        getActiveUserAction,
    };
}
//# sourceMappingURL=initialize.js.map